module.exports = __webpack_public_path__ + "img/sd.b49f7a7d.svg";